module.exports = __webpack_public_path__ + "img/bg_slider_2.6dce7d79.png";